module.exports = __webpack_public_path__ + "static/img/2.62cb2c4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/partner/2.png
// module id = VpGf
// module chunks = 45